import { render, staticRenderFns } from "./InfoMain.vue?vue&type=template&id=39fdd0e0&scoped=true&"
import script from "./InfoMain.vue?vue&type=script&lang=js&"
export * from "./InfoMain.vue?vue&type=script&lang=js&"
import style0 from "./InfoMain.vue?vue&type=style&index=0&id=39fdd0e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fdd0e0",
  null
  
)

export default component.exports